import {savedOrderDetailsAddressModalStyles as styles} from '@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsAddressModal';
import { css } from "styled-components";

styles.selectCustomerRadio = {
    ...styles.selectCustomerRadio,
    css: css`
        ${styles.selectCustomerRadio?.css}
        input + label::before {
            border: 1px solid #aaa;
        }
    `,
}